//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RecurringReminders",
  components: {
    MaterialInput
  },
  mixins: [validationMixin],
  validations: {
    sendReminderEveryDays: {
      required,
      minValue: minValue(1)
    }
  },
  props: {
    applicationNotificationFrequency: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      sendReminderEveryDays: this.applicationNotificationFrequency ? this.applicationNotificationFrequency : 7
    };
  },
  computed: {
    isActive: {
      get() {
        return this.applicationNotificationFrequency;
      },
      set(isReminderActive) {
        this.$emit("submit", isReminderActive ? this.sendReminderEveryDays : 0);
      }
    }
  },
  methods: {
    handleFormChange() {
      this.$emit("allow-save", !this.$v.$invalid);
    },
    handleSubmit() {
      this.$emit("submit", this.sendReminderEveryDays);
    }
  }
});